export const USERS = {
  login: "login",
  loginGoogle: "login/google",
  users: "add-user",
};

export const CONTACT = {
  sendmail: "sendmail",
};

// export const PROJECTS = {
//   projects: "projects",
//   project: "projects/:id",
// };
